import { IAppState } from 'models/store.models'
import { IPermission } from 'models/permission.model'

export const getPermissions = (state: IAppState): IPermission[] =>
  state.auth.user?.permissions || []
export const getIsLoggedIn = (state: IAppState): boolean =>
  state.auth.isLoggedIn
